import routes from '@/modules/product/routes'
import store from '@/modules/product/store'

export default { routes, store }
